import { useContext } from "react"
import { Check2Square, Square } from "react-bootstrap-icons"
import SimpleColourPicker from "../../../../../components/colour/SimpleColourPicker"
import GenericIconPicker from "../../../../../components/icons/GenericIconPicker"
import PriorityPicker from "../../../../../components/priority/PriorityPicker"
import ToggleButton from "../../../../../components/ui/toggle_button/ToggleButton"
import { ToDoListAdminContext } from "../ToDoListAdmin"
import TitleBarComponent from "./TitleBarComponent"
import ToggleContainerComponent from "./ToggleContainerComponent"

export default function ToDoListItemsStatusLineItem({ group, list, item }) {

    const { RemoveStatus, RenameStatus, SetStatusProperty, setToDoListItemDefaultStatus } = useContext(ToDoListAdminContext)



    const _handleSetProps = (k, v) =>
        SetStatusProperty(item.id, k, v)

    const _findValue = (k) => {
        if (!item.properties) return
        const _prop = item.properties.find((p) => p.property === k)
        if (_prop)
            return _prop.value
        return undefined
    }
    if (!item) return
    return (<div className='ps-3'>
        <TitleBarComponent title={item.item}
            container={<div className='d-flex align-items-center'>
                <div className='flex-grow-1'>{item.item}</div>
                <button onClick={() => setToDoListItemDefaultStatus(group, list, item)} className='btn btn-xs'>
                    {item.isDefault ? <Check2Square className='me-2' size='20' /> : <Square className='me-2' size='20' />}Default Status
                </button>
            </div>}
            onRemove={async () => RemoveStatus(group, list, item.id)}
            onEdit={(name) => RenameStatus(group, list, item, name)}
        />

        <ToggleContainerComponent open={false}
            focused={{
                group: group.id,
                item: list.id,
                status: item.id,
                properties: undefined
            }}
            header={<small>Properties</small>}>
            <div>
                <div className='d-flex p-1 flex-column justify-content-between small'>
                    <div className='d-flex  align-items-center position-relative'>
                        <div className='w-50'>Default Colour</div>
                        <div className='w-50'><SimpleColourPicker onChange={(v) => _handleSetProps("COLOUR", v)} defaultValue={_findValue("COLOUR")} popup={true} /></div>
                    </div>
                    <div className='d-flex justify-content-between align-items-center position-relative'>
                        <div className='w-50'>Default Icon</div>
                        <div className='w-50'><GenericIconPicker onChange={(v) => _handleSetProps("ICONS", JSON.stringify(v))} defaultValue={_findValue("ICONS") && JSON.parse(_findValue("ICONS"))} dropdown={true} /></div>
                    </div>
                    <div className='d-flex justify-content-between align-items-center position-relative'>
                        <div className='w-50'>Default Severity</div>
                        <div className='w-50 text-dark'><PriorityPicker onChange={(v) => _handleSetProps("SEVERITY", v)} defaultValue={_findValue("SEVERITY")} /></div>
                    </div>
                    <div className='d-flex justify-content-between align-items-center position-relative'>
                        <div className='w-50'>Remove From List Once Selected</div>
                        <div className='w-50'><ToggleButton size={30} onToggle={(v) => _handleSetProps("REMOVE_ON_SELECTED", JSON.stringify(v))} defaultValue={_findValue("REMOVE_ON_SELECTED") && JSON.parse(_findValue("REMOVE_ON_SELECTED"))} style='tick'></ToggleButton></div>
                    </div>
                </div>
            </div>
        </ToggleContainerComponent>
    </div>)
}